import React, { useState } from 'react';

import './ListOfEmployeesTooltip.scss';
import { IScheduleInfo } from 'types/listOfEmployees';
interface Props {
  text: IScheduleInfo[];
  children: React.ReactNode;
}

interface IGroupedItems {
  check: string;
  dateText: string;
  day: string;
  timeText: string;
}
const ListOfEmployeesTooltip = ({ text, children }: Props) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const dayFormat = (day: string): string => {
    if (day === '1') {
      return '월';
    } else if (day === '2') {
      return '화';
    } else if (day === '3') {
      return '수';
    } else if (day === '4') {
      return '목';
    } else if (day === '5') {
      return '금';
    } else if (day === '6') {
      return '토';
    } else if (day === '0') {
      return '일';
    } else {
      return '';
    }
  };

  function groupScheduleItemsByTime(scheduleItems: IScheduleInfo[]): IGroupedItems[] {
    const groupedItems: IGroupedItems[] = [];

    for (const item of scheduleItems) {
      const check = `${item.START} ~ ${item.END || '계속'} ${item.ATTENDANCE_TIME || ''} ~ ${item.WORK_OFF_TIME || ''}`;
      const dateText = `${item.START} ~ ${item.END || '계속'}`;
      const timeText = `${item.ATTENDANCE_TIME || ''} ~ ${item.WORK_OFF_TIME || ''}`;

      if (groupedItems.find((i) => i.check === check)) {
        groupedItems.find((i, idx) => {
          i.check === check;

          groupedItems[idx].day = groupedItems[idx].day.concat(`,${dayFormat(item.DAY)}`);
        });
      } else {
        groupedItems.push({
          check,
          dateText,
          timeText,
          day: dayFormat(item.DAY),
        });
      }
    }

    return groupedItems;
  }

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}>
      {text && showTooltip && text.length !== 0 && (
        <div className="tooltip">
          {groupScheduleItemsByTime(text).map((t) => {
            return (
              <div key={t.dateText}>
                <div className="tooltip-row" style={{ whiteSpace: 'nowrap' }}>
                  {`${t.dateText}   ${t.day} ${t.timeText}`}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {children}
    </div>
  );
};

export default ListOfEmployeesTooltip;
